// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__RNSdG","wrapper":"Footer_wrapper__PQ-1l","copyright":"Footer_copyright__GRNjJ","box":"Footer_box__vvWrg","link":"Footer_link__BXF0O"};